const SURVEY_PATH_PREFIX = '/mem/survey/';

const routes = {
  TALK: '/mem/talk',
  TALKMAIL: '/mem/talkmail',
  SURVEY: '/mem/survey/:surveyId',
  SURVEY_PATH_PREFIX,
  RICHMENU_ADD_FRIEND: '/mem/richmenu/add-friend',
};

export { routes, SURVEY_PATH_PREFIX };
